import { createRootRoute, Outlet, Link } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { CloudIcon, ArrowUpRightIcon } from '../components/Icons'
import '../App.css'

const TRUCO_URL = 'https://trucogame.com/'

export const rootRoute = createRootRoute({
  component: () => (
    <>
      <header className="navbar">
        <div className="nav-container">
          <Link to="/" className="brand" aria-label="Cloudymedia home">
            <span className="brand-mark">
              <CloudIcon />
            </span>
            <span className="brand-text">Cloudymedia</span>
          </Link>
          <nav className="nav-links" aria-label="Main">
            <Link to="/" className="nav-link" activeProps={{ className: 'nav-link active' }}>
              Home
            </Link>
            <Link to="/games" className="nav-link" activeProps={{ className: 'nav-link active' }}>
              Games
            </Link>
            <Link to="/about" className="nav-link" activeProps={{ className: 'nav-link active' }}>
              About
            </Link>
            <Link to="/contact" className="nav-link" activeProps={{ className: 'nav-link active' }}>
              Contact
            </Link>
            <a
              href={TRUCO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-sm nav-cta"
            >
              Play Truco
              <ArrowUpRightIcon />
            </a>
          </nav>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <Link to="/" className="brand">
                <span className="brand-mark">
                  <CloudIcon />
                </span>
                <span>Cloudymedia</span>
              </Link>
              <p className="footer-tagline">
                An independent game studio building mobile, web and social games
                from Buenos Aires, Argentina.
              </p>
            </div>

            <div className="footer-col">
              <span className="footer-heading">Studio</span>
              <Link to="/games">Games</Link>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
            </div>

            <div className="footer-col">
              <span className="footer-heading">Gran Truco Argentino</span>
              <a href={TRUCO_URL} target="_blank" rel="noopener noreferrer">
                Play on web
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.cloudymedia.trucowebview&hl=es_AR"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Play
              </a>
              <a
                href="https://apps.apple.com/ar/app/gran-truco-argentino/id6753727331"
                target="_blank"
                rel="noopener noreferrer"
              >
                App Store
              </a>
            </div>

            <div className="footer-col" lang="pt-BR">
              <span className="footer-heading">Joga Truco</span>
              <a href="https://jogatruco.com/" target="_blank" rel="noopener noreferrer">
                Jogar truco online
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.cloudymedia.jogatruco"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Play
              </a>
              <a
                href="https://apps.apple.com/br/app/joga-truco/id6821099759"
                target="_blank"
                rel="noopener noreferrer"
              >
                App Store
              </a>
            </div>
          </div>

          <div className="footer-bottom">
            <span>© {new Date().getFullYear()} Cloudymedia · Buenos Aires, Argentina</span>
            <span className="status">
              <i className="status-dot" />
              all systems operational
            </span>
          </div>
        </div>
      </footer>

      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </>
  ),
})
